import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const getCertificateByProgramId = (programId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.DISTRIBUTE.GET_CERTIFICATE_BY_PROGRAMID(programId)
  );
};

export default getCertificateByProgramId;
